/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Works_3Inputs */

const en_vc_status_works_3 = /** @type {(inputs: Vc_Status_Works_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type with styles, threading and right-to-left scripts`)
};

const zh_vc_status_works_3 = /** @type {(inputs: Vc_Status_Works_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带样式的文字、文本串接和从右到左书写的文字`)
};

/**
* | output |
* | --- |
* | "Type with styles, threading and right-to-left scripts" |
*
* @param {Vc_Status_Works_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_works_3 = /** @type {((inputs?: Vc_Status_Works_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Works_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_works_3(inputs)
	return zh_vc_status_works_3(inputs)
});
export { vc_status_works_3 as "vc.status.works.3" }